import { render } from "./ReservationRatingModel.vue?vue&type=template&id=002010c9&scoped=true"
import script from "./ReservationRatingModel.vue?vue&type=script&lang=js"
export * from "./ReservationRatingModel.vue?vue&type=script&lang=js"

import "./ReservationRatingModel.vue?vue&type=style&index=0&id=002010c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002010c9"]])

export default __exports__